// extracted by mini-css-extract-plugin
export default {"outer":"Majik_outer__+V7Zw","wrapper":"Majik_wrapper__TxZV3","footer":"Majik_footer__isJCJ"};